import { useParams } from 'react-router-dom';
import { AlertType, useAlert } from 'src/components/AlertsProvider';
import ModalDialog, {
  ModalCloseHandler,
  ModalCloseReason,
} from 'src/components/ModalDialog';
import { pepApiRequest, RequestMethod, useStatefulApi } from 'src/services';
import { generateApiPath } from 'src/utils';
import { API_SUBSCRIPTION_ITEM } from '../../constants';
import { SolutionSubscriptionItem } from '../../types';

type Props = {
  item: SolutionSubscriptionItem;
  open: boolean;
  onClose: ModalCloseHandler;
};

function SolutionSubscriptionDeleteModal({ item, open, onClose }: Props) {
  const { solutionId } = useParams();
  const { showAlert } = useAlert();
  const [handleRemove, loading] = useStatefulApi(
    () =>
      pepApiRequest({
        method: RequestMethod.Delete,
        url: generateApiPath(API_SUBSCRIPTION_ITEM, {
          solutionId,
          subscriptionId: item?.id,
        }),
      }),
    () => {
      showAlert({
        type: AlertType.Info,
        title: 'Subscription deleted',
        text: 'Subscription has been deleted successfully.',
      });
      onClose(null, ModalCloseReason.completeAction);
    }
  );

  return (
    <ModalDialog
      open={open}
      title="Remove subscription"
      loading={loading}
      onClose={onClose}
      onConfirm={handleRemove}
      cancelBtnText="No"
      confirmBtnText="Yes"
    >
      Are you sure to remove the subscription&nbsp;
      <b>{item?.name}</b>?
    </ModalDialog>
  );
}

export default SolutionSubscriptionDeleteModal;
